import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const CustomListItem = ({ heading, text, info }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                justifyContent: 'space-between'
            }}
        >
            <Box>
                <Typography variant="h5">{heading}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="h5">{text}</Typography>
                {info !== null && info !== undefined ? (
                    <Tooltip title={info} sx={{ color: 'white' }}>
                        <IconButton>
                            <InfoIcon sx={{ color: 'white', opacity: '0.7' }} />
                        </IconButton>
                    </Tooltip>
                ) : (
                    ''
                )}
            </Box>
        </Box>
    );
};

export default CustomListItem;
